import { Dispatch, SetStateAction } from 'react';
import { Stack } from '@mui/system';
import { EnumTechPlatform } from 'tdc-web-backend/enums/enums';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { mapTechPlatform } from '../../../../../../../../../utils/enums';
import { truncate } from '../../../../../../../../../utils/helpers';
import CompanyTechPlatformsEditModal from './components/CompanyTechPlatformsEditModal';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';

interface CompanyTechPlatformsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTechPlatforms = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTechPlatformsProps) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.techPlatforms?.map((platform: EnumTechPlatform) => (
        <CustomChip
          key={platform}
          tooltipTitle={mapTechPlatform.get(platform)}
          label={
            platform &&
            truncate(mapTechPlatform.get(platform) as string, CHIP_LABEL_TRUNCATE_VALUE as number)
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}

      {companyData && isEditModalOpen && (
        <CompanyTechPlatformsEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyTechPlatforms;
